import EntityChallengeImportModal from './EntityChallengeImportModal';

export default EntityChallengeImportModal;
